import getPathToRedirectLoggedInUser from '@/mixins/getPathToRedirectLoggedInUser'
import store from '@/store'

export default async (to, from, next) => {
  const postcode = store.getters['postcode/postcode']

  switch (true) {
    case Boolean(
      store.getters['auth/isAuthenticated']() &&
        from.path.indexOf('/buchungsstatus/uebersicht') > -1,
    ):
      next()
      break

    case Boolean(store.getters['auth/isAuthenticated']()):
      try {
        next(await getPathToRedirectLoggedInUser())
        break
      } catch (error) {
        next('/anfrage')
        break
      }

    case Boolean(!store.getters['auth/isAuthenticated']() && !postcode):
      next('/anfrage')
      break

    case Boolean(!store.getters['auth/isAuthenticated']() && postcode):
      next()
      break

    default:
      next('/anfrage')
      break
  }
}
